<template>
  <div class="flex flex-col items-center max-w-lg mx-auto my-5 px-8 md:px-10 pt-6 pb-10 border rounded border-sc-gray-light shadow-sc-secondary">
    <div class="flex items-center w-full mb-6 text-xs text-sc-gray">
      <img
        :src="require('@assets/images/blue-checked.svg')"
        class="h-8 my-2 px-4 opacity-75"
      >
      <div class="w-full px-2">
        <h1
          class="text-xl md:text-3xl leading-9 text-primary"
        >
          {{ $t('message.onboarding.successStep.success') }}
        </h1>
      </div>
    </div>
    <button
      @click="$emit('next')"
      class="w-full md:w-auto px-10 py-2 text-sm leading-6 text-center text-white rounded cursor-pointer bg-sc-blue"
    >
      {{ $t('message.onboarding.successStep.button') }}
    </button>
  </div>
</template>
<script>

export default {
};
</script>
